import React from 'react';
import {MultiSelect} from './MultiSelect';
import { withFormikFormControl } from '../FormikFormControl';
import {addCollabOptions, wrapComponent} from "../utils";
import {FormPageFieldComponentDefaultProps} from "types/formPage";

export const MultiCollabs = ({  ...props }: FormPageFieldComponentDefaultProps) => {
  const withOptions = addCollabOptions(props)
  const comp = <MultiSelect  {...withOptions} />;
  return comp

};

export const MultiCollabsFormik = withFormikFormControl()(MultiCollabs);

export default MultiCollabsFormik;
